import { cn } from "@/lib/utils";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import type { ThemeSortField, SortDir } from "./useThemeSort";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function SortHeader({
  label,
  field,
  sortField,
  sortDir,
  onSort,
  className,
  tooltip,
}: {
  label: string;
  field: ThemeSortField;
  sortField: ThemeSortField;
  sortDir: SortDir;
  onSort: (f: ThemeSortField) => void;
  className?: string;
  tooltip?: React.ReactNode;
}) {
  const active = sortField === field;
  return (
    <button
      onClick={() => onSort(field)}
      className={cn(
        "flex items-center justify-center gap-1 font-semibold text-sm w-full",
        "text-foreground",
        className,
      )}
    >
      {tooltip ? (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger
              className="cursor-help border-b border-dotted border-muted-foreground"
              onClick={(e) => e.preventDefault()}
            >
              {label}
            </TooltipTrigger>
            <TooltipContent side="bottom">{tooltip}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        label
      )}
      <span className="shrink-0">
        {active ? (
          sortDir === "desc" ? <ArrowDown className="h-3 w-3" /> : <ArrowUp className="h-3 w-3" />
        ) : (
          <ArrowUpDown className="h-3 w-3 opacity-40" />
        )}
      </span>
    </button>
  );
}
